'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _panelsUi = require('panels-ui');

var _browserVendorPrefix = require('browser-vendor-prefix');

var _style = require('../style');

var _reactRedux = require('react-redux');

var _widgetsAction = require('../widgets/action');

var _widgetsAction2 = _interopRequireDefault(_widgetsAction);

var _widgetsInfo = require('../widgets/info');

var _widgetsInfo2 = _interopRequireDefault(_widgetsInfo);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsSponsor = require('../widgets/sponsor');

var _widgetsSponsor2 = _interopRequireDefault(_widgetsSponsor);

var TournamentCard = function TournamentCard(props) {
  var actionStyle = {
    borderColor: _style.WHITE_TRANSPARENT,
    color: _style.WHITE
  };

  if (props.i === 0) {
    actionStyle.marginTop = 75;
  }

  return _react2['default'].createElement(
    _widgetsAction2['default'],
    { href: props.tournament.id + '/', style: actionStyle },
    props.tournament.name
  );
};

exports.TournamentCard = TournamentCard;
var Social = function Social(props) {
  return _react2['default'].createElement(
    'a',
    { href: props.href, target: '_blank', title: props.name, className: 'Social' },
    _react2['default'].createElement('img', { src: '/icons/' + props.name + '.svg', alt: props.name, style: style.icon })
  );
};

var socialStyle = _react2['default'].createElement(
  'style',
  null,
  '\n  .Social {\n    transition: all 0.25s linear;\n  }\n  .Social:hover {\n    transform: scale(1.2);\n  }'
);

var socialLinks = [{
  name: 'facebook',
  href: 'https://www.facebook.com/editorialmundialpolo'
}, {
  name: 'twitter',
  href: 'https://twitter.com/EdiMundial'
}, {
  name: 'instagram',
  href: 'https://instagram.com/editorialmundial'
}];

var Home = function Home(props) {
  return _react2['default'].createElement(
    _panelsUi.Panel,
    { width: props.width, style: style.panel },
    _react2['default'].createElement(
      'h1',
      { style: style.title },
      'Polo Mundial'
    ),
    _react2['default'].createElement(_widgetsSponsor2['default'], _extends({}, props.sponsor, { colour: 'WHITE' })),
    props.tournaments.list.map(function (tournament, i) {
      return _react2['default'].createElement(TournamentCard, { tournament: props.tournaments.byId[tournament], i: i, key: i });
    }),
    _react2['default'].createElement(
      'div',
      { style: style.icons },
      socialStyle,
      socialLinks.map(function (link) {
        return _react2['default'].createElement(Social, _extends({}, link, { key: link.name }));
      })
    ),
    _react2['default'].createElement(
      _panelsUi.Action,
      { href: 'https://uxtemple.com/', style: style.UXtemple },
      _react2['default'].createElement(_widgetsInfo2['default'], { type: 'uxtemple', text: 'made by UXtemple in Panels' })
    )
  );
};

exports.Home = Home;
var style = {
  icon: {
    marginRight: 10,
    width: 35
  },
  icons: _extends({}, _browserVendorPrefix.alignItemsCenter, _browserVendorPrefix.flexDirectionRow, {
    marginTop: 75
  }),
  panel: {
    backgroundColor: _style.BLUE_TRANSPARENT,
    color: _style.WHITE,
    fontFamily: _style.FONT,
    fontWeight: _style.FONT_LIGHT,
    paddingBottom: 200,
    paddingLeft: 35,
    paddingRight: 35
  },
  sponsorLogo: {
    marginTop: 5,
    width: '40%'
  },
  sponsoredBy: {
    fontSize: 14,
    marginTop: 5
  },
  title: {
    fontSize: 40,
    fontWeight: _style.FONT_LIGHT,
    marginTop: 90,
    textTransform: 'uppercase'
  },
  UXtemple: {
    color: _style.WHITE,
    marginTop: 75,
    textDecoration: 'none'
  }
};

function mapStateToProps(state, props) {
  return {
    tournaments: state.tournaments,
    sponsor: state.tournaments.sponsorsById['sancor-seguros']
  };
}

exports['default'] = _reactRedux.connect(mapStateToProps)(Home);